/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';

import './App.less';

// import PDF from './components/pdf';
import CyberSecurityTraining from './pages/cyber-security-training';
// import Course from './pages/cyber-security-training/course/course';
import HotTopic from './pages/cyber-security-training/hottopic/hot-topic';
import { useStore } from './pages/cyber-security-training/store';
import MainCourse from './pages/cyber-security-training/mainCourse';

function App() {
  const { language } = useStore();
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<CyberSecurityTraining />} />
        <Route path="/tc" element={<CyberSecurityTraining />} />
        <Route path="/en" element={<CyberSecurityTraining />} />
        <Route path="/sc" element={<CyberSecurityTraining />} />
        <Route path="/tc/course/:course/*" element={<MainCourse />} />
        <Route path="/en/course/:course/*" element={<MainCourse />} />
        <Route path="/sc/course/:course/*" element={<MainCourse />} />
        <Route path="/course/:course/*" element={<MainCourse />} />
        <Route path="/tc/hottopic/:topic/*" element={<HotTopic />} />
        <Route path="/en/hottopic/:topic/*" element={<HotTopic />} />
        <Route path="/sc/hottopic/:topic/*" element={<HotTopic />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
